import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=67b0a079&scoped=true&"
import script from "./Blog.vue?vue&type=script&lang=js&"
export * from "./Blog.vue?vue&type=script&lang=js&"
import style0 from "./Blog.vue?vue&type=style&index=0&id=67b0a079&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b0a079",
  null
  
)

export default component.exports